import Vue from 'vue'
import Toasted from 'vue-toasted'

import App from './App.vue'

Vue.use(Toasted)

new Vue({
  el: '#app-client-forget',
  render: h => h(App)
})




// WEBPACK FOOTER //
// ./src/client_forget/index.js